module.exports = __webpack_public_path__ + "img/unlike.b41caf38.svg";